export type TwitterCardType = 'summary' | 'summary_large_image' | 'app' | 'player';

export type SeriesBasePath =
  | 'series'
  | 'video-series'
  | 'audio-series'
  | 'image-galleries';

export interface SeriesMetadata {
  _id: string;
  seriesId: string;
  seriesType: 'post_series' | 'video_series' | 'audio_series' | 'image_gallery';
  orgId: string;
  metaDescription: string | null;
  keywords: string[] | null;
  ogUrl: string | null;
  ogImage: string | null;
  twitterCard: TwitterCardType | null;
  twitterImage: string | null;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertSeriesMetadataRequest {
  metaDescription?: string | null;
  keywords?: string[] | null;
  ogUrl?: string | null;
  ogImage?: string | null;
  twitterCard?: TwitterCardType | null;
  twitterImage?: string | null;
}

export const TWITTER_CARD_OPTIONS: TwitterCardType[] = [
  'summary',
  'summary_large_image',
  'app',
  'player',
];
